import { useState } from "react";
import { useHistory } from "react-router-dom";

import {
    Button, Chip, Dialog, DialogActions,
    DialogContent, DialogTitle, Typography
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

import solicitationService from "../../domain/services/solicitation/solicitation.service";
import loginService from "../../domain/services/login.service";

function FaciliterCorrectionDropout({ request, setAlert, setIsLoading }) {

    const history = useHistory();

    const [open, setOpen] = useState(false);

    const handleConfirm = async () => {

        setOpen(false);

        return onConfirm();
    }

    const onConfirm = async () => {

        setIsLoading(true)

        return solicitationService
            .faciliterCorrectionDropout(request.id, loginService.getUserAuthentication()?.faciliter?.id)
            .then(() => history.push("/solicitations"))
            .catch(err => setAlert((err.response.data.message || "Erro ao solicitar a desistência"), "error"))
            .finally(() => setIsLoading(false));
    }


    return (
        <>

            <Chip
                label="Desistir da Correção"
                icon={<Cancel />}
                onClick={() => setOpen(true)}
                variant="outlined"
                style={{ height: '100%' }}
            />

            <Dialog open={open} onClose={() => setOpen(false)}>

                <DialogTitle style={{ backgroundColor: '#eee' }}>
                    Desistir da correção
                </DialogTitle>

                <DialogContent>
                    <div style={{ padding: "10px" }}>
                        <Typography>
                            Ao desistir da correção, você não recebe o pagamento deste serviço e a solicitação volta para a operação dar o encaminhamento.
                        </Typography>
                        <Typography style={{ marginTop: 12 }}>
                            Desistências entram no seu histórico e podem afetar a sua continuidade na plataforma. Se ainda houver prazo, concluir a correção é sempre a melhor saída.
                        </Typography>
                    </div>
                </DialogContent>

                <DialogActions>

                    <Button onClick={() => setOpen(false)} color="primary">
                        Cancelar
                    </Button>

                    <Button
                        onClick={() => handleConfirm()}
                        style={{ color: "#FF5959" }}
                    >
                        Desistir da correção
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}

export default FaciliterCorrectionDropout;
